<template>
  <div>
    <md-dialog
      v-model="addCardVisible"
      :title="$t('add_new_bank')"
      :closable="false"
      :btns="btns"
    >
      {{ content }}
    </md-dialog>
  </div>
</template>

<script>
import { Dialog } from 'mand-mobile'
import { mapMutations } from 'vuex'
export default {
  name: 'AddCardDialog',
  components: {
    [Dialog.name]: Dialog
  },
  data () {
    return {
      content: '',
      btns: [
        {
          text: this.$t('cancel'),
          handler: this.onBasicCancel
        },
        {
          text: this.$t('add'),
          handler: this.onBasicConfirm
        }
      ]
    }
  },
  computed: {
    addCardVisible: {
      get () {
        const { name } = this.$store.state
        if (name === 'TopUp' && this.$store.state.addCardVisible) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.content = this.$t('please_add_bank_account')
        }
        if (name === 'Withdraw' && this.$store.state.addCardVisible) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.content = this.$t('please_add_bank_account')
        }
        return this.$store.state.addCardVisible
      },
      set () {}
    }
  },
  methods: {
    ...mapMutations(['change_addCardVisible']),
    onBasicConfirm () { // 确认按钮
      this.$router.push({ name: 'Card' })
      this.change_addCardVisible(false)
    },
    onBasicCancel () { // 取消按钮
      this.change_addCardVisible(false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .md-dialog-body {
  text-align: center;
  line-height: 48px;
}

::v-deep .md-dialog-content {
  border-radius: 32px;
}
</style>
